export type Environments = "production" | "development" | "staging" | "test";

const shouldUseEnvFileValues = (): Boolean => {
  return process.env.REACT_APP_INFER_ENV_FROM_DOMAIN !== "true";
};
// for errors we want in rollbar and the console, but do not want to interrupt the flow of the application
const asyncThrow = function (message: string) {
  setTimeout(() => {
    throw new Error(message);
  }, 0);
};

const inferEnvFromDomain = function (): Environments | undefined {
  let env: Environments | undefined;
  const environmentMap: Partial<Record<Environments, RegExp>> = {
    production: /prod\.vibe\.justworks\.com/,
    staging: /nonprod\.vibe\.justworks\.com/,
    development: /localhost/,
  };

  for (const [environmentName, envRegex] of Object.entries(environmentMap)) {
    if (envRegex.test(document.domain)) {
      env = environmentName as Environments;
    }
  }
  return env;
};

export function getEnvironmentName(): Environments {
  const production: Environments = "production";
  let environmentName: Environments = process.env
    .REACT_APP_APP_ENVIRONMENT as Environments;

  if (!shouldUseEnvFileValues()) {
    const domainEnv = inferEnvFromDomain();
    if (domainEnv === undefined) {
      asyncThrow(
        "Cannot resolve environment. Could not infer from page domain. Defaulting to 'production'"
      );
    }
    environmentName = domainEnv || production;
  }

  return environmentName;
}
